import { API } from 'api';

// Matches the encoding done in Python when creating the links for Slack. At least, it matches
// it enough for the type of data we are expecting here
const quotePlus = (str: string): string =>
  encodeURIComponent(str).replace(/%20/g, '+');

export const postApproval = async (
  externalSource: string,
  externalId: string,
): Promise<void> => {
  await API.post(
    `geo_events_external/${quotePlus(externalSource)}:${quotePlus(externalId)}/approve`,
  );
};
